import { useAppConfigContext } from '@/context/AppConfig';

export const usePermalinkFromParams = () => {
  const { useSearchParams } = useAppConfigContext().routingUtils;
  const [searchParams] = useSearchParams();
  const permalinkFromParams = searchParams.get('permalink') || '';
  return { permalinkFromParams };
};
